import React from 'react';
import PropTypes from "prop-types";
export var BreadcrumbResponsiveMaxCount = function BreadcrumbResponsiveMaxCount() {
  return ___EmotionJSX("div", null);
};
export var BreadcrumbProps = () => <div />;
BreadcrumbProps.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,

  /**
       * Visible label of the breadcrumb
       */
  text: PropTypes.node.isRequired,

  /**
       * Force a max-width on the breadcrumb text
       */
  truncate: PropTypes.bool,

  /**
       * Accepts any EuiLink `color` when rendered as one (has `href` or `onClick`)
       */
  color: PropTypes.any,

  /**
       * Override the existing `aria-current` which defaults to `page` for the last breadcrumb
       */
  "aria-current": PropTypes.any
};

try {
  BreadcrumbResponsiveMaxCount.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/breadcrumbs/props.tsx',
    description: '',
    displayName: 'BreadcrumbResponsiveMaxCount',
    methods: [],
    props: {
      xs: {
        defaultValue: null,
        description: '',
        name: 'xs',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      s: {
        defaultValue: null,
        description: '',
        name: 's',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      m: {
        defaultValue: null,
        description: '',
        name: 'm',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      l: {
        defaultValue: null,
        description: '',
        name: 'l',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      },
      xl: {
        defaultValue: null,
        description: '',
        name: 'xl',
        parent: undefined,
        declarations: undefined,
        required: false,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'CommonProps']
  };
} catch (e) {}

try {
  BreadcrumbProps.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/breadcrumbs/props.tsx',
    description: '',
    displayName: 'BreadcrumbProps',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        }, {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        },
        declarations: [{
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        }, {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      text: {
        defaultValue: null,
        description: 'Visible label of the breadcrumb',
        name: 'text',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      truncate: {
        defaultValue: null,
        description: 'Force a max-width on the breadcrumb text',
        name: 'truncate',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/breadcrumbs/breadcrumbs.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'CommonProps']
  };
} catch (e) {}